// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"backup"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 14.5C1 17.5376 3.46243 20 6.5 20H17.5C20.5376 20 23 17.5376 23 14.5C23 11.7994 21.0536 9.55346 18.4872 9.08835C18.2748 5.69029 15.4516 3 12 3C8.54842 3 5.72518 5.69029 5.51282 9.08835C2.94636 9.55346 1 11.7994 1 14.5Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 14.5C1 17.5376 3.46243 20 6.5 20H17.5C20.5376 20 23 17.5376 23 14.5C23 11.7994 21.0536 9.55346 18.4872 9.08835C18.2748 5.69029 15.4516 3 12 3C8.54842 3 5.72518 5.69029 5.51282 9.08835C2.94636 9.55346 1 11.7994 1 14.5Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 11.5L12 8.5L9 11.5M12 16V13M12 13V9V12V13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BackupIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'backup',
    ref,
    icon: element,
  },
));

BackupIcon.displayName = 'BackupIcon';

export default BackupIcon;
